import { render, staticRenderFns } from "./QueryListItemHeader.vue?vue&type=template&id=20ed64ac&scoped=true"
import script from "./QueryListItemHeader.vue?vue&type=script&lang=js"
export * from "./QueryListItemHeader.vue?vue&type=script&lang=js"
import style0 from "./QueryListItemHeader.vue?vue&type=style&index=0&id=20ed64ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ed64ac",
  null
  
)

export default component.exports